import { clientApi } from 'shared/api/clientApi'
import { Response } from 'shared/models/general'

import { BlackListPassenger } from './model'

export const BlackListAvia = {
  checkBlackList(body: BlackListPassenger[], abort?: AbortSignal) {
    return clientApi.post<Response<BlackListPassenger[]>>(
      '/flights/tickets/black-list-check',
      {
        passengers: body,
      },
      { signal: abort },
    )
  },
}
